import i18n from '@/lang/i18n'
import { initialScientificAnalysisSaveModalState, ScientificAnalysisSaveModalState } from '@/modules/scientific-analysis-module/components/scientific-analysis-save-modal/scientific-analysis-save-modal.models'
import { ScientificAnalysisSaveResponse, ScientificAnalysisTemplateHeader } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { scientificAnalysisService, ScientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { ScientificAnalysis, SCIENTIFIC_ANALYSIS_CURRENT_SCHEMA_VERSION } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Nullable } from '@/shared/types/app.types'
import { Vue, Component, Ref } from 'vue-property-decorator'

@Component
export default class ScientificAnalysisSaveModal extends Vue {
    state: ScientificAnalysisSaveModalState
    service: ScientificAnalysisService = scientificAnalysisService
    @Ref() readonly scientificAnalysisSaveModal!: any

    constructor() {
        super()
        this.state = initialScientificAnalysisSaveModalState()
    }

    get _showClone(): boolean {
        return this.state.existingId !== null
    }

    public show(updatedAnalysis: ScientificAnalysis, existingDTO: Nullable<ScientificAnalysisSaveResponse>): void {
        this.state.clone = false
        this.state.name = ''
        this.state.existingId = null
        if (existingDTO) {
            this.state.existingId = existingDTO.id
            this.state.name = existingDTO.name
        }
        this.state.scientificAnalysis = updatedAnalysis
        this.scientificAnalysisSaveModal.show()
    }

    public hide(): void { this.scientificAnalysisSaveModal.hide() }

    async _onSaveClick(): Promise<void> {
        if (this.state.name.length > 0 && this.state.scientificAnalysis !== null) {
            let templateHeader: ScientificAnalysisTemplateHeader | null
            if (this.state.clone || this.state.existingId === null) {
                templateHeader = await this.$_toCallSecureLoading(this.service.createTemplate(this.state.name, SCIENTIFIC_ANALYSIS_CURRENT_SCHEMA_VERSION, JSON.stringify(this.state.scientificAnalysis)))
            } else {
                templateHeader = await this.$_toCallSecureLoading(this.service.updateTemplate(this.state.existingId, this.state.name, SCIENTIFIC_ANALYSIS_CURRENT_SCHEMA_VERSION, JSON.stringify(this.state.scientificAnalysis)))
            }
            if (templateHeader) {
                this.$emit('templateSaved', templateHeader)
                this.$_showToastSuccess(i18n.tc('scientificAnalysis.sidebar.savesuccess'))
                this.hide()
            }
        }
    }

    _toggleClone(): void {
        this.state.clone = !this.state.clone
    }
}
